import { createStore } from "vuex";
// import { Page } from "@/router/index";
import { DispatchType } from "@/store/app.config";

export default createStore({
    state: {
        // nowPage: Page.TOP, //ページの現在地
        nowPage: "Top",
        params: JSON.parse(sessionStorage.getItem('searchParams') || '[]'),
    },
    getters: {
        nowPage: (state) => state.nowPage,
    },
    mutations: {
        setPage(state, newPage) {
            // if (newPage == "All") newPage = "Top";
            state.nowPage = newPage;
        },
        setParams(state, params) {
            state.params = params;
            sessionStorage.setItem('searchParams', JSON.stringify(params));
        },
        resetParams(state) {
            state.params = [];
            sessionStorage.removeItem('searchParams');
        },
    },
    actions: {
        setPage({ commit }, newPage) {
            commit(DispatchType.SET_PAGE, newPage);
        },
    },
    modules: {},
});
